/**
 * CetusEd Community Portal — Button Component
 *
 * COMPLIANCE: Buttons for destructive actions (e.g., declining a consent
 *   form) require confirmation via aria attributes. All interactive elements
 *   must have accessible names per WCAG 2.1 AA (SC 4.1.2).
 */

import React from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  children,
  className = '',
  ...props
}) => {
  const classes = [
    'community-btn',
    `community-btn--${variant}`,
    `community-btn--${size}`,
    isLoading ? 'community-btn--loading' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={classes}
      disabled={disabled || isLoading}
      aria-busy={isLoading}
      {...props}
    >
      {isLoading ? <span className="btn-spinner" aria-hidden="true" /> : children}
    </button>
  );
};
